import { render, staticRenderFns } from "./HeroSass.vue?vue&type=template&id=7c781434&scoped=true&"
import script from "./HeroSass.vue?vue&type=script&lang=js&"
export * from "./HeroSass.vue?vue&type=script&lang=js&"
import style0 from "./HeroSass.vue?vue&type=style&index=0&id=7c781434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c781434",
  null
  
)

export default component.exports